import type { OpaqueVideoData } from '@lumen5/luminary';
import { createAction } from '@reduxjs/toolkit';

import { VIDEO_DATA_ACTIONS } from 'js/src/data/video-data/video-data-types';

export const setVideoData = createAction<{
    video_data: OpaqueVideoData;
    systemTriggered: boolean;
    parentActionGroup: string | undefined;
}>(VIDEO_DATA_ACTIONS.SET_VIDEO_DATA);

/**
 * This method checkpoints (ie. saves) the provided video data which should be obtained by calling Luminary.save().
 * This data is the serialized Luminary state which we can use for:
 *      (a) saving to the database/server
 *      (b) undo/redo
 * We should NOT read this data directly as the data structure itself is not guaranteed and may change!
 * @param video_data
 * @param systemTriggered
 * @param parentActionGroup
 */
export const checkpointVideo = createAction<{
    // NOTE: this is an IDENTICAL copy to setVideoData above in execution, just a different name
    //       to help with the different use case
    video_data: OpaqueVideoData;
    systemTriggered: boolean;
    parentActionGroup: string | undefined;
}>(VIDEO_DATA_ACTIONS.SET_VIDEO_DATA);
